import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getRootUrl } from 'helpers/url';
import FromNow from '../Date/FromNow';
import Status from '../Status';
import { isUserTeacher } from 'helpers/user';
import { ColorLabel, ColorLabelContainer } from 'UI';
import { Icon, Card } from '@haldor/ui';
import './_AssignmentCard.scss';

var AssignmentCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AssignmentCard, _React$PureComponent);

  var _super = _createSuper(AssignmentCard);

  function AssignmentCard() {
    _classCallCheck(this, AssignmentCard);

    return _super.apply(this, arguments);
  }

  _createClass(AssignmentCard, [{
    key: "render",
    value: function render() {
      var _this$props$assignmen, _this$props$assignmen2, _this$props$assignmen3, _this$props$assignmen4;

      var translate = this.props.translate;
      var isHaldorAssignment = this.props.assignment.id == parseInt(this.props.assignment.id, 10);

      if (this.props.assignment.status == null) {
        // Wait for status requests
        return null;
      }

      var addedColorDots = [];
      var assignmentId = (_this$props$assignmen = this.props.assignment.externalID) !== null && _this$props$assignmen !== void 0 ? _this$props$assignmen : this.props.assignment.id;
      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement(Card, {
        element: Link,
        to: "".concat(getRootUrl(), "assignment/").concat(assignmentId),
        className: "assignment-card"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, isHaldorAssignment && this.props.assignment.courses != null && this.props.assignment.courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, null, this.props.assignment.courses.map(function (course) {
        if (addedColorDots.find(function (t) {
          return t == course.id;
        }) == null) {
          var text = course.title;
          text = course.year != null ? text + ' ' + course.year : text;
          addedColorDots.push(course.id);
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: course.id,
            tooltip: text,
            color: course.colorCode
          });
        }
      })) : null, isHaldorAssignment ? /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.assignment.title) : /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.assignment.displayName), isHaldorAssignment ? /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 'var(--size-14)'
        }
      }, this.props.assignment.section != null ? this.props.assignment.section.title : '') : null), /*#__PURE__*/React.createElement("div", {
        className: "meta-container"
      }, /*#__PURE__*/React.createElement("div", null, this.props.assignment.status === 'ASSIGNMENT_LOCKED' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: 5
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Lock"
      }), this.props.translate('Locked'), ' ', isTeacher ? /*#__PURE__*/React.createElement(Fragment, null, ((_this$props$assignmen2 = this.props.assignment) === null || _this$props$assignmen2 === void 0 ? void 0 : _this$props$assignmen2.lockedWorkspaces) === 0 ? 0 : (_this$props$assignmen3 = this.props.assignment) === null || _this$props$assignmen3 === void 0 ? void 0 : _this$props$assignmen3.lockedWorkspaces, " /", ' ', (_this$props$assignmen4 = this.props.assignment) === null || _this$props$assignmen4 === void 0 ? void 0 : _this$props$assignmen4.totalTasks) : null) : null, isHaldorAssignment ? this.props.assignment.created != '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement(FromNow, null, this.props.assignment.dueDate) : null : /*#__PURE__*/React.createElement(FromNow, null, this.props.assignment.dueDateTime), this.props.assignment.assessmentId != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, this.props.translate('assessed')) : null, !isHaldorAssignment || this.props.assignment.externalID != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: 5
        }
      }, /*#__PURE__*/React.createElement("span", null, "Teams")) : this.props.assignment.created == '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement("span", {
        className: "badge-primary"
      }, this.props.translate('task-is-creating')) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, /*#__PURE__*/React.createElement(Status, {
        type: "assignmentTypes",
        id: this.props.assignment.assignmentType
      }))), /*#__PURE__*/React.createElement("div", {
        className: "submission-info"
      }, this.props.assignment.submittedTasks != null && this.props.isTeacher ? /*#__PURE__*/React.createElement("div", {
        "data-tooltip": translate('submitted-list-title') + ' ' + translate('tasks'),
        className: "card-meta"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block',
          width: 11,
          height: 19
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "File"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block',
          marginLeft: 7
        }
      }, translate('submitted-list-title'), ' ', this.props.assignment.submittedTasks, " /", ' ', this.props.assignment.totalTasks)) : null, this.props.assignment.publishedAssessments != null && this.props.isTeacher ? /*#__PURE__*/React.createElement("div", {
        "data-tooltip": translate('published-assessments'),
        className: "card-meta"
      }, translate('assessed-tasks'), ' ', this.props.assignment.publishedAssessments) : null)));
    }
  }]);

  return AssignmentCard;
}(React.PureComponent);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    status: state.status.status,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps)(AssignmentCard);